import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError } from 'rxjs/operators';

// eslint-disable-next-line @typescript-eslint/naming-convention
const ADMINV1HOSTNAME = 'staging.talentlitmus.com';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private _router;
  constructor(private _authenticationService: AuthService, inj: Injector) {
    this._router = inj.get(AuthService);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if user is logged in and request is to the api url
    const currentUser = this._authenticationService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.access_token;

    // const isApiUrl = request.url.startsWith(environment.apiUrl);
    if (
      isLoggedIn &&
      (request.url.includes('.talentlitmus.com') ||
        request.url.includes('http://localhost:3001'))
    ) {
      const url = new URL(request.url);

      // if this is a request to v1 server
      if (url.hostname === ADMINV1HOSTNAME) {
        request = request.clone({
          setHeaders: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Authorization: `Bearer ${currentUser['v1'].token}`,
          },
        });
      } else {
        request = request.clone({
          setHeaders: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Authorization: `Bearer ${currentUser.access_token}`,
          },
        });
      }
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this._router.logout();
          return throwError(error);
        } else {
          return throwError(error);
        }
      }),
    );
  }
}
